module.exports = __webpack_public_path__ + "static/img/loginindex.f0515f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/loginindex.png
// module id = 1244
// module chunks = 0